import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { TransitionGroup } from "react-transition-group";

import {
  isAuthenticated,
  ReadDataStorage,
  TOKEN_KEY,
  EMP_DATA,
  USERNAME,
} from "./services/auth";
import { useDispatch } from "react-redux";

import Login from "./pages/login.js";
import Logoff from "./pages/logoff.js";
import Error404 from "./pages/errors/404.js";
import Main from "./pages/main.js";
import PolicyAndPrivacy from "./pages/policyAndPrivacy.js";
import { setUser, setEmpresaID } from "./store/login";

const Routes = (props) => {
  const dispatch = useDispatch();

  const getPage = (name) => {
    if (isAuthenticated()) {
      // console.log("routes.getPage(isAuthenticated)");
      let _user = JSON.parse(ReadDataStorage(TOKEN_KEY));
      let _emp = JSON.parse(ReadDataStorage(EMP_DATA));
      // console.log("routes.getPage(Usuário): ", _user);
      // console.log("routes.getPage(Empresa): ", _emp);

      dispatch(setUser(_user));
      dispatch(setEmpresaID(_emp));
    }

    if (name.indexOf("documentostec") >= 0)
      return <Route path={`/${name}`} component={Main} />
    else
      return isAuthenticated() ? (
        <Route exact path={`/${name}`} component={Main} />
      ) : (
        <Redirect to="/login" />
      );
  };

  return (
    <TransitionGroup>
      <BrowserRouter>
        <Switch>
          <Route exact path="/agenda" render={() => getPage("agenda")} />
          <Route exact path="/spm" render={() => getPage("spm")} />
          <Route path="/documentostec" render={() => getPage("documentostec")} />
          <Route
            exact
            path="/integracao"
            render={() => getPage("integracao")}
          />
          <Route exact path="/estoque" render={() => getPage("estoque")} />
          <Route exact path="/atendimento" render={() => getPage("atendimento")} />
          <Route exact path="/vendas" render={() => getPage("vendas")} />
          <Route exact path="/user-settings" render={() => getPage("user-settings")} />
          <Route exact path="/" render={() => <Redirect to="/agenda" />} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/logoff" component={Logoff} />
          <Route exact path="/politica-e-privacidade" component={PolicyAndPrivacy} />
          <Route path="/*" component={Error404} />
        </Switch>
      </BrowserRouter>
    </TransitionGroup>
  );
};

export default Routes;
